import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import { CareOrdersWrapper } from '../../../../containers/Blotters/CareOrders/CareOrdersWrapper';
import type { CareOrdersPanelConfig } from '../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { BlotterPanel } from './blotters/BlotterPanel';

export function CareOrdersPanel({ api, params }: LayoutPanelProps<CareOrdersPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.CareOrderBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="care-orders-panel"
        background="backgroundBody"
      >
        <CareOrdersWrapper panelId={api.id} />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
